<template>
  <div>
    <common-table :url="url"
                  :table-columns="tableColumns"
                  :form-fields="formFields"
                  :operate="operate"
                  :permission="permission"
                  :searchs="searchs"
                  :buttons="buttons"
                  :auto-update="true"
                  ref="table">
    </common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "UsdtPayEnergyConfig",
  components: {CommonTable},
  data() {
    return {
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      searchs: [
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
        }
      ],
      permission:{
        add: 'usdtPayEnergyConfig:add',
        update: 'usdtPayEnergyConfig:update',
        delete: 'usdtPayEnergyConfig:delete',
        deleteBatch: 'usdtPayEnergyConfig:deleteBatch'
      },
      url: {
        get: '/usdtPayEnergyConfig/listByCondition',
        add: '/usdtPayEnergyConfig/add',
        update: '/usdtPayEnergyConfig/update',
        delete: '/usdtPayEnergyConfig/delete/',
        delete_batch: '/usdtPayEnergyConfig/deleteBatch',
        status: '/usdtPayEnergyConfig/status'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'account',
        label: '账户',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'pwd',
        label: '密码',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'balance',
        label: '余额',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'payNums',
        label: '租用数量',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'resType',
        label: '资源类型',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'status',
        label: '是否启用',
        show: true,
        detail: false,
        width: '',
        status: true
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        detail: false,
        width: ''
      },],
      formFields: {
        addTitle: '添加账户',
        updateTitle: '修改账户',
        labelWidth: '90px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'account',
          label: '账户：',
          type: 'input',
          placeholder: '账户',
          rules:[{
            message: '请输入账户', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'pwd',
          label: '密码：',
          type: 'input',
          placeholder: '密码',
          rules:[{
            message: '请输入密码', trigger: 'blur', required: true
          }],
          add: true,
          update: true
        }, {
          field: 'payNums',
          label: '租用数量：',
          type: 'input',
          placeholder: '租用数量,默认->32600',
          rules:[],
          add: true,
          update: true
        }, {
          field: 'resType',
          label: '资源类型：',
          type: 'input',
          placeholder: '资源类型,ENERGY：能量，BANDWIDTH：带宽',
          rules:[],
          add: true,
          update: true
        }]
      },
      operate: [],
      buttons: []
    }
  },
  methods: {}
}
</script>

<style scoped>

</style>
